import {Pipe, PipeTransform} from '@angular/core';
import {LgpdMaskingType} from '../core/enum/LgpdMaskingType';

@Pipe({
    name: 'lgpdMask'
})
export class LgpdMaskPipe implements PipeTransform {
    transform(value: string, maskType: LgpdMaskingType): any {
        switch (maskType) {
            case LgpdMaskingType.CPF:
                return this.maskCpf(value);
            case LgpdMaskingType.CNPJ:
                return this.maskCnpj(value);
            case LgpdMaskingType.NAME:
                return this.maskName(value);
            default:
                return value;
        }
    }

    private maskCpf(cpf: string): string {
      return cpf;
    }

    private maskCnpj(cnpj: string): string {
      return cnpj;
    }

    private maskName(nameToMask: string): string {
      const auxNameArray = nameToMask.split(' ');
      return auxNameArray[0];
    }
}
